export const link = 'https://merchant.estackk.com/';

export const backEndLink = 'https://api.estackk.com';

export const playMarketLink =
  'https://play.google.com/store/apps/details?id=com.estackk.loyalty.customer.app';

export const appStoreLink =
  'https://apps.apple.com/us/app/estackk/id1543391439';
